// libraries
import React from "react";

// styles
import styles from "./styles.module.scss";

// assets
import search from "src/assets/images/navbar/search.svg";

const SearchBar = ({ searchTerm, setSearchTerm }) => {
  return (
    <label className={styles.search_bar}>
      <img src={search} alt="search_bar" />
      <input
        placeholder="Find events"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        type="search"
      />
    </label>
  );
};

export default SearchBar;
